import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';
import { defaultDiacriticsRemovalMap } from '../../helpers/ascii_helper';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import NumberFormat from 'react-number-format';
import InputMask from 'react-input-mask';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import BtnLoader from '../../components/Loaders/btnLoader';
import { countryOptions } from '../../helpers/country_helper';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Alert,
} from 'reactstrap';

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';

import PageLoader from '../../components/Loaders/pageLoader';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { WsEvents } from '../../app-socket/events';
import { socket } from '../../app-socket/socket';

import { getLostOrders } from "../../store/lostOrders/actions"
import { onAddLostOrder, onDeleteLostOrder, onUpdateLostOrder } from '../../app-socket/events/lost-orders';
import { onAddBattlefield } from '../../app-socket/events/battlefield';
import { getScreenHeight } from '../../helpers/screen_height_helper';

import { Notification } from '../../components/Notifications/notifications';

class LostOrdersList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lostOrder: [],
      lostOrders: [],
      correctDate: true,
      displayHidden: false,
      modalNewLostOrder: false,
      modalNewBattlefieldOrder: false,
      isNewClicked: false,
      isEdit: false,
      alert: null,
      curDate: new Date().toLocaleString('en-GB'),
      error: '',
      orderDate: '',
      LostOrdersListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Date',
          dataField: 'date',
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          csvFormatter: (cell, row, rowIndex) =>
            row.date != null && new Date(row.date).toLocaleDateString('en-GB'),
          formatter: (cellContent, lostOrder) => (
            <h5 className='font-size-16 mb-1'>
              {lostOrder.date != null &&
                new Date(lostOrder.date).toLocaleDateString('en-GB')}
            </h5>
          )
        },
        {
          text: 'Responsible',
          dataField: 'responsible',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, lostOrder) => (
            <h5 className='font-size-16 mb-1'>
            {lostOrder.responsible && (
              <span>
                <div>
                  {!lostOrder.responsible.profilePic ? (
                  <div className='avatar-sm m-2 d-inline-block'>
                    <span className='avatar-title rounded-circle'>
                      {lostOrder.responsible.fname.charAt(0)}
                    </span>
                  </div>
                  ) : (<img className='rounded-circle avatar-sm m-2' src={lostOrder.responsible.profilePic} alt='profile pic'/>)}
                  <span>
                    {lostOrder.responsible.fname}
                    &nbsp;
                    {lostOrder.responsible.sname}
                  </span>
                </div>
              </span>
            )}
            </h5>
          )
        },
        {
          text: 'Sender',
          dataField: 'sender',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, lostOrder) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1 text-lowercase'>
                {this.removeDiacritics(lostOrder.sender)}
              </h5>
            </div>
          )
        },
        {
          text: 'Information',
          dataField: 'information',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, lostOrder) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1 text-lowercase'>
                {lostOrder.information && this.removeDiacritics(lostOrder.information)}
              </h5>
            </div>
          )
        },
        {
          text: "Client's Name",
          dataField: 'clientName',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, lostOrder) => (
            <div className='name-width'>
              <h5
                className={
                  lostOrder.newClient === true
                    ? 'font-size-16 mb-1 new-client-color'
                    : 'font-size-16 mb-1'
                }
              >
                {lostOrder.clientName}
              </h5>
            </div>
          )
        },
        {
          text: 'Invoice №',
          dataField: 'invoiceNo',
          sort: true,
          editable: false,
          csvText: 'Invoice Number',
          formatter: (cellContent, lostOrder) => (
            <h5 className='font-size-16 mb-1'>#{lostOrder.invoiceNo}</h5>
          )
        },
        {
          text: 'Payment Method',
          dataField: 'paymentMethod',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, lostOrder) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1'>{lostOrder.paymentMethod}</h5>
            </div>
          )
        },
        {
          text: 'Amount Received',
          dataField: 'amountReceived',
          sort: true,
          csvExport: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) =>
            `${
              row.currAmountReceived === '₩'
                ? 'KRW'
                : row.currAmountReceived === '$'
                ? 'USD'
                : row.currAmountReceived === '€'
                ? 'EUR'
                : row.currAmountReceived === 'AU$'
                ? 'AUD'
                : row.currAmountReceived === '£' && 'GBP'
            } ${row.amountReceived}`,
          formatter: (cellContent, lostOrder) => (
            <h5 className='font-size-16 mb-1'>
              <NumberFormat
                value={lostOrder.amountReceived}
                displayType='text'
                thousandSeparator={true}
                prefix={lostOrder.currAmountReceived}
              />
            </h5>
          )
        },
        {
          dataField: 'menu',
          //   isDummyField: true,
          text: 'Action',
          editable: false,
          formatter: (cellContent, lostOrder) => (
            <div className='d-flex gap-3'>
              {/* {!lostOrder.status && ( */}
              <>
                <Link className='text-primary' to='#'>
                  <i
                    className='fas fa-yin-yang font-size-18'
                    id='edittooltip'
                    onClick={(e) => this.handleSendLostOrderToBattlefield(e, lostOrder)}
                  ></i>
                </Link>
                <Link className='text-success' to='#'>
                  <i
                    className='mdi mdi-pencil font-size-18'
                    id='edittooltip'
                    onClick={(e) => this.handleEditLostOrderClick(e, lostOrder)}
                  ></i>
                </Link>
                <Link className='text-danger' to='#'>
                  <i
                    className='mdi mdi-delete font-size-18'
                    id='deletetooltip'
                    onClick={() => this.handleDeleteLostOrder(lostOrder)}
                  ></i>
                </Link>
              </>
              {/* )} */}
            </div>
          )
        }
      ]
    }
    // this.getScreenHeight = this.getScreenHeight.bind(this)
    this.indication = this.indication.bind(this);
    this.removeDiacritics = this.removeDiacritics.bind(this);

    this.toggleHiddenOrders = this.toggleHiddenOrders.bind(this);
    this.hiddenRowKeys = this.hiddenRowKeys.bind(this);
    this.rowClasses = this.rowClasses.bind(this);
    
    this.handleNewLostOrderClick = this.handleNewLostOrderClick.bind(this);
    this.toggleNewLostOrderModal = this.toggleNewLostOrderModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleNewLostOrderSubmit = this.handleNewLostOrderSubmit.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);

    this.toggleNewBattlefieldOrderModal = this.toggleNewBattlefieldOrderModal.bind(this);
    this.handleSendLostOrderToBattlefield = this.handleSendLostOrderToBattlefield.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.handleNewBattlefieldOrderSubmit = this.handleNewBattlefieldOrderSubmit.bind(this);
    this.onChangeSource = this.onChangeSource.bind(this);
    this.handleEditLostOrderClick = this.handleEditLostOrderClick.bind(this);
    this.handleDeleteLostOrder = this.handleDeleteLostOrder.bind(this);
  }
  componentDidMount() {
    const { onGetLostOrders } = this.props
    onGetLostOrders()
    window.addEventListener('load', getScreenHeight);
    window.addEventListener('click', getScreenHeight, { once: true });
    window.addEventListener('resize', getScreenHeight);
    // Join Lost Orders Room
    socket.emit(WsEvents.lostOrders.JOIN_ROOM, console.log)
  }
  componentWillUnmount() {
    window.removeEventListener('load', getScreenHeight);
    window.removeEventListener('click', getScreenHeight);
    window.removeEventListener('resize', getScreenHeight);
    // Leave Lost Orders Room
    socket.emit(WsEvents.lostOrders.LEAVE_ROOM, console.log)
  }
  componentDidUpdate(prevProps, prevState, ss) {
    const { lostOrders, profileData } = this.props;
    if (profileData !== prevProps.profileData || lostOrders !== prevProps.lostOrders) {
      if (profileData?.department?.depName === 'Cosmetic Brand-Suppuru') {
        const lost_orders = (lostOrders || []).filter((order) => order.responsible?._id === profileData._id);
        this.setState({ lostOrders: lost_orders.length ? lost_orders : [{ manager: 'No Results Found' }] });
      }else{
        this.setState({ lostOrders: lostOrders.length ? lostOrders : [{ manager: 'No Results Found' }] });
      }
    }
  }
  /**
   * get height of the screen
   */
  // getScreenHeight = () => {
  //   if (document.getElementById('card-section') != null) {
  //     let screenHeight = document.getElementById('card-section').offsetHeight;
  //     document
  //       .querySelector('.react-bootstrap-table')
  //       .setAttribute('style', 'height: calc(' + screenHeight + 'px - 100px); overflow: auto;');
  //   }
  // };
  /**
   * Display empty table
   * @returns empty message if no results are found
   */
  indication = () => {
    let emptyMessage = '';
    if (
      this.props.lostOrders.length !== 0 &&
      this.props.lostOrders[0]['manager'] === 'No Results Found'
    ) {
      emptyMessage = `No Results Found`;
    }
    return emptyMessage;
  };
  /**
   * Remove ascii characters
   * @param {*} str pass the string
   * @returns clear string
   */
  removeDiacritics = (str) => {
    let changes = '';
    if (!changes) {
      changes = defaultDiacriticsRemovalMap;
    }
    for (var i = 0; i < changes.length; i++) {
      str = str.replace(changes[i].letters, changes[i].base);
    }
    return str;
  };
  toggleHiddenOrders = () => {
    this.setState((prevState) => ({ displayHidden: !prevState.displayHidden }));
  };
  /**
   *
   * @param {String} oldValue
   * @param {String} newValue
   * @param {Arr} row
   * @param {String} column
   * @param {String} rowId
   * @returns saving data after editing is finsihed
   */
  afterSaveCell = (oldValue, newValue, row, column, rowId) => {
    const { /* onUpdateLostOrder,*/ dispatch } = this.props;
    setTimeout(() => {
      row[column.dataField] = newValue;
      // onUpdateLostOrder(row);
      onUpdateLostOrder({ dispatch, updateLostOrder: row });

      // if (newValue !== oldValue) {
      const result = this.state.LostOrdersListColumns.map((row_map) => {
        if (row_map.id === rowId) {
          const newRow = { ...row_map };
          newRow[column.dataField] = newValue;
          return newRow;
        }
        return row_map;
      });
      this.setState({ LostOrdersListColumns: result });
      // }
    }, 100);
    return { newValue, async: true };
  };

  /**
   * Function to check if source is Exhibition
   * @param {*} event
   */
  onChangeSource = (event) => this.setState({ source: event.target.value });
  /**
   * Empty lost order array, set is edit to false and open new modal window
   */
  handleNewLostOrderClick = () => {
    this.setState({ lostOrder: [], error: '', isEdit: false });
    this.toggleNewLostOrderModal();
  };
  /**
   * Assign values to Lost order for editing
   * @param {*} e 
   * @param {*} type 
   * @param {*} arg 
   */
  handleEditLostOrderClick = (e, lostOrder) => {
    this.setState({
      lostOrder: {
        _id: lostOrder._id,
        responsible: lostOrder.responsible,
        invoiceNo: lostOrder.invoiceNo,
        information: lostOrder.information,
        sender: lostOrder.sender,
        clientName: lostOrder.clientName,
        paymentMethod: lostOrder.paymentMethod,
        amountReceived: lostOrder.amountReceived,
        currAmountReceived: lostOrder.currAmountReceived,
        paymentStatus: 'Paid',
        status: false
      },
      curDate: new Date(lostOrder.date).toLocaleDateString('en-GB'),
      isEdit: true,
      error: '',
    });
    this.toggleNewLostOrderModal();
  };
  /**
   * Open/Close modal window for new lost order
   */
  toggleNewLostOrderModal = () => {
    this.setState((prevState) => ({
      modalNewLostOrder: !prevState.modalNewLostOrder
    }));
  };
  /**
   * Open/Close modal window for new battlefield order
   */
  toggleNewBattlefieldOrderModal = () => {
    this.setState((prevState) => ({
      modalNewBattlefieldOrder: !prevState.modalNewBattlefieldOrder
    }));
  };
  /**
   * Assign values for new battlefield order
   * @param {*} e 
   * @param {*} lostOrder 
   */
  handleSendLostOrderToBattlefield = (e, lostOrder) => {
    this.setState({
      lostOrder: {
        id: lostOrder._id,
        responsible: lostOrder.responsible,
        invoiceNo: lostOrder.invoiceNo,
        information: lostOrder.information,
        sender: lostOrder.sender,
        clientName: lostOrder.clientName,
        paymentMethod: lostOrder.paymentMethod,
        amountReceived:
          lostOrder.amountReceived !== ''
            ? lostOrder.amountReceived
            : lostOrder.information.replace(/[^0-9]/g, ''),
        currAmountReceived: lostOrder.currAmountReceived,
        paymentStatus: 'Paid',
        status: false
      },
      isNewClicked: false,
      isEdit: true,
      error: '',
      curDate: new Date(lostOrder.date).toLocaleDateString('en-GB'),
      orderDate: new Date(lostOrder.date).toLocaleDateString('en-GB')
    });
    this.toggleNewBattlefieldOrderModal();
  };
  setCountry = (event, { value }) => this.setState({ selectedCountry: value });
  /**
   * check if the date is correct
   * @param {*} event value from input
   */
  onChange = (event) => {
    if (parseFloat(event.target.value.substring(3, 5)) > 12) {
      this.setState({ correctDate: false });
    } else {
      this.setState({
        correctDate: true,
        [event.target.name]: event.target.value
      });
    }
  };

  /**
   * Submit new lost order or edit existing order
   * @param {*} e 
   * @param {*} values 
   */
  handleNewLostOrderSubmit = (e, values) => {
    const { managers, dispatch /*onAddLostOrder, onUpdateLostOrder*/ } = this.props;
    const { isEdit, curDate, lostOrder } = this.state;
    if(isEdit){
      const updateLostOrder = {
        _id: lostOrder._id,
        date: curDate.split('/').reverse().join('-'),
        responsible: values.manager,
        invoiceNo: values.invoiceNo,
        information: values.information,
        sender: values.sender,
        clientName: values.clientName,
        paymentMethod: values.paymentMethod,
        amountReceived: values.amountReceived,
        currAmountReceived: values.currAmountReceived,
        paymentStatus: 'Paid',
        status: false
      };
      // updated order
      // onUpdateLostOrder(updateLostOrder);
      onUpdateLostOrder({ dispatch, updateLostOrder });
    }else{
      const newLostOrder = {
        date: curDate.split(',')[0].split('/').reverse().join('-'),
        responsible: values['manager'],
        invoiceNo: values['invoiceNo'],
        information: values['information'],
        sender: values['sender'],
        clientName: values['clientName'],
        paymentMethod: values['paymentMethod'],
        amountReceived: values['amountReceived'],
        currAmountReceived: values['currAmountReceived'],
        paymentStatus: 'Paid',
        status: false,
        bitrixID: 'chat6296',
        fname: '',
        sname: '',
        module: 'Bot Battlefield Notification',
        option: 'newLostOrder'
      };
      managers.map((id) => {
        if (id._id === values['manager']) {
          newLostOrder['bitrixID'] = id.bitrixID;
          newLostOrder['fname'] = id.fname;
          newLostOrder['sname'] = id.sname;
        }
        return newLostOrder;
      });
      // onAddLostOrder(newLostOrder)
      onAddLostOrder({ dispatch, newOrder: newLostOrder });
    }
    this.toggleNewLostOrderModal();
  };

  /**
   * Send order tp battlfield table
   * @param {*} e 
   * @param {*} values 
   */
  handleNewBattlefieldOrderSubmit = (e, values) => {
    const { /* onAddBattlefield, onUpdateLostOrder, */ managers, dispatch, date } = this.props;
    const {lostOrder, curDate, selectedCountry} = this.state;
    const newBattlefieldOrder = {
      // _id: lostOrder.id,
      date: curDate.split('/').reverse().join('-'),
      manager: values['manager'],
      sender: values['sender'],
      clientName: values['clientName'],
      newClient: values['newClient'],
      invoiceNo: values['invoiceNo'],
      country: selectedCountry,
      region: values['region'],
      invoiceSum: values['invoiceSum'] === '' ? '0' : values['invoiceSum'],
      paymentMethod: values['paymentMethod'],
      comments: values['comments'],
      paymentStatus: values['paymentStatus'],
      source: values['source'],
      amountReceived: lostOrder.amountReceived,
      currAmountReceived: lostOrder.currAmountReceived,
      orderStatus: true,
      notificationSent: false,
      receivedDate: curDate.split('/').reverse().join('-'),
      startDate: date.startDate,
      year: date.year,
      month: date.month,
    };
    const updateLostOrder = {
      _id: lostOrder.id,
      manager: values['manager'],
      invoiceNo: values['invoiceNo'],
      sender: values['sender'],
      paymentMethod: values['paymentMethod'],
      amountReceived: lostOrder.amountReceived,
      currAmountReceived: lostOrder.currAmountReceived,
      status: true,

      fname: '',
      sname: '',
      module: 'Bot Battlefield Notification',
      option: 'sendLostOrderToBattlefield'      
    }
    managers.map((id) => {
      if (id._id === values['manager']) {
        updateLostOrder['bitrixID'] = id.bitrixID;
        updateLostOrder['fname'] = id.fname;
        updateLostOrder['sname'] = id.sname;
      }
      return updateLostOrder;
    });
    // onAddBattlefield(newBattlefieldOrder);
    // onUpdateLostOrder(updateLostOrder);
    onAddBattlefield({ dispatch, order: newBattlefieldOrder })
    onUpdateLostOrder({ dispatch, updateLostOrder: updateLostOrder });
    this.toggleNewBattlefieldOrderModal();
  };
  /**
   * Delete order from the table
   * @param {*} lostOrder selected order
   */
  handleDeleteLostOrder = (lostOrder) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteAlert(lostOrder._id)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Display alert for deleting an order
   * @param {*} lostOrder selected order
   */
  deleteAlert = (id) => {
    const { /*onDeleteLostOrder*/ dispatch } = this.props;
    // onDeleteLostOrder(id);
    onDeleteLostOrder({ dispatch, id });
    this.hideAlert();
  };
  /**
   * Hide alert
   * @returns 
   */
  hideAlert = () => this.setState({ alert: null });
  /**
   * Hide/Display taken orders 
   * @returns array of orders
   */
  hiddenRowKeys = () => {
    let hiddenArr = [];
    this.props.lostOrders.map((order, index) => {
      if (order.status === true && this.state.displayHidden === false) {
        hiddenArr.push(order._id);
      }
    });
    return hiddenArr;
  };
  /**
   * Assign class to each table row
   * @param {*} row
   * @param {*} rowIndex
   * @returns css class
   */
  rowClasses = (row, rowIndex) => {
    let classes = null;
    if (row.status === true) {
      classes = 'completed-row';
    }
    return classes;
  };
  render() {
    const { SearchBar } = Search;
    const { profileData, loading, managers } = this.props;
    const { lostOrders, isEdit, error, curDate, orderDate, correctDate, lostOrder, isNewClicked } = this.state;
    const pageOptions = {
      sizePerPage: lostOrders.length,
      sizePerPageList: [500, 1000, 1500],
      totalSize: lostOrders.length,
      custom: true
    };
    const defaultSorted = [
      {
        dataField: 'date', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];
    return (
      <React.Fragment>
        <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>
        <div className='page-content'>
          <MetaTags>
            <title>Lost Orders</title>
          </MetaTags>
          <Container fluid>
          {profileData.permissions.includes('battlefieldAccess') ? (
            <>
              {/* Render Breadcrumbs */}
              <Breadcrumbs title='Korupharma' breadcrumbItem='Lost Orders' />
              <Row id='card-section' onLoad={getScreenHeight()}>
                <Col lg='12'>
                  <Card>
                    <CardBody className='cardBodySticky'>
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField='_id'
                        columns={this.state.LostOrdersListColumns}
                        data={lostOrders}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField='_id'
                            columns={this.state.LostOrdersListColumns}
                            data={lostOrders}
                            search
                          >
                            {(toolkitprops) => (
                              <React.Fragment>
                                <Row className='mb-2'>
                                  <Col md='2' sm='12' className='d-flex'>
                                    <div className='search-box ms-2 mb-2 me-5 d-inline-block '>
                                      <div className='position-relative'>
                                        <SearchBar {...toolkitprops.searchProps} />
                                        <i className='bx bx-search-alt search-icon' />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md='2' sm='12' className='d-flex'>
                                    <Notification compData={lostOrders} keyWord='lost' module='Bot Battlefield Notification' />
                                  </Col>
                                  <Col md='6' sm='12'>
                                    <div className='text-sm-start'>
                                      <Button
                                        color='success'
                                        className='font-16 btn-block btn btn-success btn-lg'
                                        onClick={this.toggleHiddenOrders}
                                        id='create-order-btn'
                                      >
                                        {this.state.displayHidden ? (
                                          <>
                                            <i className='mdi mdi-file me-1' />
                                            Hide Taken Orders
                                          </>
                                        ) : (
                                          <>
                                            <i className='mdi mdi-file-hidden me-1' />
                                            Show Taken Orders
                                          </>
                                        )}
                                      </Button>
                                    </div>
                                  </Col>
                                  <Col md='2' sm='12'>
                                    <div className='text-sm-end'>
                                      <Button
                                        color="primary"
                                        className="font-16 btn-block btn btn-primary btn-lg"
                                        onClick={this.handleNewLostOrderClick}
                                      >
                                        <i className="mdi mdi-plus-circle-outline me-1" />
                                        Add Payment
                                      </Button>
                                      <Modal
                                        size='lg'
                                        autoFocus={false}
                                        isOpen={this.state.modalNewLostOrder}
                                        className={this.props.className}
                                        toggle={this.toggleNewLostOrderModal}
                                      >
                                        <ModalHeader toggle={this.toggleNewLostOrderModal} tag='h4'>
                                          {!!isEdit ? 'Edit Payment' : 'Add Payment'}
                                        </ModalHeader>
                                        <ModalBody>
                                          {error !== '' && error ? (
                                            <Alert color='danger'>{error} </Alert>
                                          ) : null}
                                          <AvForm onValidSubmit={this.handleNewLostOrderSubmit}>
                                            <Row>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <Label>Date</Label>
                                                  <InputMask
                                                    mask='99/99/9999'
                                                    value={curDate}
                                                    name='curDate'
                                                    onChange={this.onChange}
                                                    className={
                                                      correctDate
                                                        ? ' form-control input-mask'
                                                        : 'form-control input-mask is-invalid'
                                                    }
                                                  />
                                                  {!correctDate && (
                                                    <div className='invalid-feedback'>
                                                      Invalid Date. Please use dd/mm/yyyy format
                                                    </div>
                                                  )}
                                                </FormGroup>
                                              </Col>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name='information'
                                                    label='Information'
                                                    type='text'
                                                    autoComplete='off'
                                                    value={lostOrder.information || ''}
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    type='select'
                                                    name='manager'
                                                    className='form-select'
                                                    label='Manager'
                                                    value={
                                                      lostOrder.responsible
                                                        ? lostOrder.responsible._id
                                                        : ''
                                                    }
                                                  >
                                                    <option>Unknown</option>

                                                    {managers.map((manager) => {
                                                      return (
                                                        <option
                                                          key={manager._id}
                                                          value={manager._id}
                                                        >
                                                          {manager.fname} {manager.sname}
                                                        </option>
                                                      );
                                                    })}
                                                  </AvField>
                                                </FormGroup>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name='invoiceNo'
                                                    label='Invoice №'
                                                    type='text'
                                                    autoComplete='off'
                                                    value={lostOrder.invoiceNo || ''}
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name='sender'
                                                    label='Sender'
                                                    type='text'
                                                    autoComplete='off'
                                                    errorMessage='Invalid Sender Name'
                                                    value={lostOrder.sender || ''}
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name='clientName'
                                                    label="Client's Name"
                                                    type='text'
                                                    autoComplete='off'
                                                    value={lostOrder.clientName || ''}
                                                  />
                                                </FormGroup>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name='paymentMethod'
                                                    label='Payment method'
                                                    type='select'
                                                    autoComplete='off'
                                                    value={
                                                      lostOrder.paymentMethod || ''
                                                    }
                                                  >
                                                    <option value='' disabled>
                                                      -- Select a payment method --
                                                    </option>
                                                    <optgroup label='Koru Pharma bank accounts'>
                                                      <option>Woori Bank KRW</option>
                                                      <option>Woori Bank USD/GBP/EUR/AUD</option>
                                                      <option>Kookmin Bank KRW</option>
                                                      <option>Kookmin Bank USD</option>
                                                      <option>Shinhan Bank KRW</option>
                                                      <option>Shinhan Bank USD</option>
                                                      <option>Hana bank KRW</option>
                                                      <option>Hana bank USD</option>
                                                    </optgroup>
                                                    <optgroup label='Card terminal + cash'>
                                                      <option>Card Terminal</option>
                                                      <option>Cash Korea</option>
                                                      <option>Cash Malaysia</option>
                                                      <option>Cash exhibition</option>
                                                    </optgroup>
                                                    <optgroup label='Other payments'>
                                                      <option>Payoneer</option>
                                                      <option>Western Union</option>
                                                      <option>ONLINE</option>
                                                    </optgroup>
                                                    <optgroup label='Ukraine payments'>
                                                      <option>Card UKR</option>
                                                      <option>Cash UKR</option>
                                                      <option>FOP UKR</option>
                                                    </optgroup>
                                                    <optgroup label='UAE payments'>
                                                      <option>COD</option>
                                                    </optgroup>
                                                  </AvField>
                                                  {/* <AvField
                                                    name='paymentMethod'
                                                    label='Payment method'
                                                    autoComplete='off'
                                                    list='urls'
                                                    value={
                                                      lostOrder.paymentMethod || ''
                                                    }
                                                  />
                                                  <datalist id='urls'>
                                                    <optgroup label='Bank'>
                                                      <option>Western Union</option>
                                                      <option>Woori Bank USD/GBP/EUR/AUD</option>
                                                      <option>Woori Bank KRW</option>
                                                      <option>Kookmin Bank USD</option>
                                                      <option>Kookmin Bank KRW</option>
                                                      <option>Shinhan Bank USD</option>
                                                    </optgroup>
                                                    <optgroup label='Western Union'>
                                                      <option>Vernidub Roman</option>
                                                    </optgroup>
                                                    <optgroup label='Cash'>
                                                      <option>Cash to Anatolii</option>
                                                      <option>Cash to Sim Maksim</option>
                                                      <option>Cash to Olga Kiev</option>
                                                      <option>Cash to Denis Yaroshenko Kiev</option>
                                                      <option>Cash to Andrey Myakushko Kiev</option>
                                                      <option>Cash to Vitalii Serkin</option>
                                                    </optgroup>
                                                    <optgroup label='Cryptocurrency'>
                                                      <option>BTC</option>
                                                      <option>ONLINE</option>
                                                      <option>XRP</option>
                                                    </optgroup>
                                                    <option>Client's Card</option>
                                                    <option>Wechat</option>
                                                  </datalist> */}
                                                </FormGroup>
                                              </Col>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name='amountReceived'
                                                    label='Amount Received'
                                                    type='number'
                                                    errorMessage='Please input correct amount'
                                                    value={
                                                      lostOrder.amountReceived || ''
                                                    }
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    type='select'
                                                    name='currAmountReceived'
                                                    className='form-select'
                                                    label='Currency'
                                                    errorMessage='Please select currency'
                                                    validate={{
                                                      required: {
                                                        value: true
                                                      }
                                                    }}
                                                    value='₩'
                                                  >
                                                    <option value='₩'> ₩ KRW </option>
                                                    <option value='$'> $ USD </option>
                                                    <option value='€'> € EUR </option>
                                                    <option value='AU$'> AU$ AUD </option>
                                                    <option value='£'> £ GBP </option>
                                                  </AvField>
                                                </FormGroup>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div className='text-end'>
                                                  {loading && <BtnLoader />}
                                                  <button
                                                    className='btn btn-success save-user'
                                                    disabled={
                                                      !correctDate ||
                                                      (loading && true)
                                                    }
                                                  >
                                                    {!!isEdit ? 'Edit Lost Order' : 'Add Lost Order'}
                                                  </button>
                                                </div>
                                              </Col>
                                            </Row>
                                          </AvForm>
                                        </ModalBody>
                                      </Modal>
                                    </div>
                                  </Col>
                                </Row>
                                <Row id='table-section'>
                                  <BootstrapTable
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    defaultSorted={defaultSorted}
                                    classes={'table align-middle table-nowrap'}
                                    headerClasses='header-class is-sticky-hdr'
                                    id='tableScroll'
                                    filter={filterFactory()}
                                    noDataIndication={this.indication}
                                    hiddenRows={this.hiddenRowKeys()}
                                    rowClasses={this.rowClasses}
                                    responsive
                                    cellEdit={cellEditFactory({
                                      mode: 'click',
                                      blurToSave: true,
                                      afterSaveCell: this.afterSaveCell
                                    })}
                                  />
                                  <Modal
                                    size='xl'
                                    isOpen={this.state.modalNewBattlefieldOrder}
                                    className={this.props.className}
                                    toggle={this.toggleNewBattlefieldOrderModal}
                                  >
                                    <ModalHeader toggle={this.toggleNewBattlefieldOrderModal} tag='h4'>
                                      Send Order to Battlefield
                                    </ModalHeader>
                                    <ModalBody>
                                      <AvForm onValidSubmit={this.handleNewBattlefieldOrderSubmit}>
                                        <Row>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <Label>Date</Label>
                                              <InputMask
                                                mask='99/99/9999'
                                                value={orderDate}
                                                name='orderDate'
                                                onChange={this.onChange}
                                                className={
                                                  correctDate
                                                    ? ' form-control input-mask'
                                                    : 'form-control input-mask is-invalid'
                                                }
                                              />
                                              {!correctDate && (
                                                <div className='invalid-feedback'>
                                                  Invalid Date. Please use dd/mm/yyyy format
                                                </div>
                                              )}
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                type='select'
                                                name='manager'
                                                className='form-select'
                                                label='Manager'
                                                errorMessage='Please select manager'
                                                validate={{
                                                  required: {
                                                    value: true
                                                  }
                                                }}
                                                value={
                                                  lostOrder.responsible
                                                    ? lostOrder.responsible._id
                                                    : profileData._id
                                                }
                                              >
                                                <option>Choose</option>
                                                {managers.map((manager) => {
                                                  return (
                                                    <option
                                                      key={manager._id}
                                                      value={manager._id}
                                                    >
                                                      {manager.fname} {manager.sname}
                                                    </option>
                                                  );
                                                })}
                                              </AvField>
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='sender'
                                                label='Sender'
                                                type='text'
                                                autoComplete='off'
                                                value={lostOrder.sender || ''}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='clientName'
                                                label="Client's Name"
                                                type='text'
                                                errorMessage="Invalid Client's Name"
                                                autoComplete='off'
                                                validate={{
                                                  required: {
                                                    value: true
                                                  }
                                                }}
                                                value={lostOrder.clientName || ''}
                                              />
                                            </FormGroup>
                                            <FormGroup className='mb-3 new-client'>
                                              <Label
                                                htmlFor='customCheckcolor1'
                                                className='form-check-label new-client-label'
                                              >
                                                <i className='mdi mdi-new-box mdi-24px' />
                                              </Label>
                                              <AvField
                                                name='newClient'
                                                type='checkbox'
                                                className='form-check-input new-client-input '
                                                id='customCheckcolor1'
                                                value={lostOrder.newClient || ''}
                                                onClick={() => this.setState({ isNewClicked: !this.state.isNewClicked })}
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='invoiceNo'
                                                label='Invoice №'
                                                type='text'
                                                errorMessage='Invalid Invoice №'
                                                autoComplete='off'
                                                validate={{
                                                  required: {
                                                    value: true
                                                  }
                                                }}
                                                value={lostOrder.invoiceNo || ''}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='invoiceSum'
                                                label='Amount Sent'
                                                autoComplete='off'
                                                type='number'
                                                value={lostOrder.invoiceSum || 0}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <Label htmlFor='country_selector'>Country</Label>
                                              <Dropdown
                                                placeholder='Select Country'
                                                fluid
                                                search
                                                selection
                                                options={countryOptions}
                                                name='country'
                                                required
                                                defaultValue={this.state.selectedCountry}
                                                onChange={this.setCountry}
                                                id='country_selector'
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='region'
                                                label='Region/City'
                                                autoComplete='off'
                                                type='text'
                                                value={lostOrder.region || ''}
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='paymentMethod'
                                                label='Payment method'
                                                autoComplete='off'
                                                type='select'
                                                value={
                                                  lostOrder.paymentMethod || ''
                                                }
                                                validate={
                                                  this.state.paymentStatus !== 'Not Paid'
                                                    ? {
                                                        required: {
                                                          value: true
                                                        }
                                                      }
                                                    : {
                                                        required: {
                                                          value: false
                                                        }
                                                      }
                                                }
                                              >
                                                <option value='' disabled>
                                                  -- Select a payment method --
                                                </option>
                                                <optgroup label='Koru Pharma bank accounts'>
                                                  <option>Woori Bank KRW</option>
                                                  <option>Woori Bank USD/GBP/EUR/AUD</option>
                                                  <option>Kookmin Bank KRW</option>
                                                  <option>Kookmin Bank USD</option>
                                                  <option>Shinhan Bank KRW</option>
                                                  <option>Shinhan Bank USD</option>
                                                  <option>Hana bank KRW</option>
                                                  <option>Hana bank USD</option>
                                                </optgroup>
                                                <optgroup label='Card terminal + cash'>
                                                  <option>Card Terminal</option>
                                                  <option>Cash Korea</option>
                                                  <option>Cash Malaysia</option>
                                                  <option>Cash exhibition</option>
                                                </optgroup>
                                                <optgroup label='Other payments'>
                                                  <option>Payoneer</option>
                                                  <option>Western Union</option>
                                                  <option>ONLINE</option>
                                                </optgroup>
                                                <optgroup label='Ukraine payments'>
                                                  <option>Card UKR</option>
                                                  <option>Cash UKR</option>
                                                  <option>FOP UKR</option>
                                                </optgroup>
                                                <optgroup label='UAE payments'>
                                                  <option>COD</option>
                                                </optgroup>
                                              </AvField>
                                              {/* <AvField
                                                name='paymentMethod'
                                                label='Payment method'
                                                // label={this.state.paymentStatus}
                                                autoComplete='off'
                                                list='pms'
                                                value={
                                                  lostOrder.paymentMethod || ''
                                                }
                                                validate={
                                                  this.state.paymentStatus !== 'Not Paid'
                                                    ? {
                                                        required: {
                                                          value: true
                                                        }
                                                      }
                                                    : {
                                                        required: {
                                                          value: false
                                                        }
                                                      }
                                                }
                                              />
                                              <datalist id='pms'>
                                                <optgroup label='Bank'>
                                                  <option>Woori Bank USD/GBP/EUR/AUD</option>
                                                  <option>Woori Bank KRW</option>
                                                  <option>Kookmin Bank USD</option>
                                                  <option>Kookmin Bank KRW</option>
                                                  <option>Shinhan Bank USD</option>
                                                </optgroup>
                                                <optgroup label='Western Union'>
                                                  <option>Vernidub Roman</option>
                                                </optgroup>
                                                <optgroup label='Cash'>
                                                  <option>Cash to Anatolii</option>
                                                  <option>Cash to Sim Maksim</option>
                                                  <option>Cash to Olga Kiev</option>
                                                  <option>Cash to Denis Yaroshenko Kiev</option>
                                                  <option>Cash to Andrey Myakushko Kiev</option>
                                                  <option>Cash to Vitalii Serkin</option>
                                                </optgroup>
                                                <optgroup label='Cryprocurrency'>
                                                  <option>BTC</option>
                                                  <option>ONLINE</option>
                                                  <option>XRP</option>
                                                </optgroup>
                                                <option>Client's Card</option>
                                                <option>Wechat</option>
                                              </datalist> */}
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                type='select'
                                                name='paymentStatus'
                                                className='form-select'
                                                label='Payment status'
                                                value={
                                                  lostOrder.paymentStatus || ''
                                                }
                                              >
                                                <option>Not Paid</option>
                                                <option>Paid</option>
                                                <option>Paid and sent</option>
                                              </AvField>
                                            </FormGroup>
                                          </Col>

                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='comments'
                                                label='Commentary'
                                                autoComplete='off'
                                                type='text'
                                                value={lostOrder.comments || ''}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md={3}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                type='select'
                                                name='source'
                                                className='form-select'
                                                label='Source'
                                                value={lostOrder.source || ''}
                                                onChange={this.onChangeSource}
                                                required={isNewClicked}
                                                errorMessage='Please select the source'
                                              >
                                                <option value=''>-//-</option>
                                                <option>Korupharma Website</option>
                                                <option>Found by manager</option>
                                                <option>Jivo chat </option>
                                                <option>Recommendation</option>
                                                <option>Facebook</option>
                                                <option>Xiaohongshu</option>
                                                <option>Baidu</option>
                                                <option>Wechat</option>
                                                <option>Instagram</option>
                                                <option>Exhibition</option>
                                                <option>Email</option>
                                              </AvField>
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col>
                                            <div className='text-end'>
                                              {loading && <BtnLoader />}
                                              <button
                                                // type="submit"
                                                className='btn btn-success save-user'
                                                disabled={
                                                  !correctDate ||
                                                  (loading && true)
                                                }
                                              >
                                                Send Order to Battlefield
                                              </button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </ModalBody>
                                  </Modal>
                                  <Col className='inner-custom-pagination d-flex mt-1'>
                                    <div className='d-inline'>
                                      <SizePerPageDropdownStandalone {...paginationProps} />
                                    </div>
                                    <div className='text-md-right ms-auto pagination pagination-rounded justify-content-end mb-2'>
                                      <PaginationListStandalone {...paginationProps} />
                                    </div>
                                  </Col>
                                </Row>
                                {this.state.alert}
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color='danger'> You do not have access to this page. </Alert>
          )}
          </Container>     
        </div>
      </React.Fragment>
    )
  }
}

LostOrdersList.propTypes = {
  lostOrders: PropTypes.array,
  onGetLostOrders: PropTypes.func,
  // onAddLostOrder: PropTypes.func,
  // onUpdateLostOrder: PropTypes.func,
  // onDeleteLostOrder: PropTypes.func,
}

const mapStateToProps = ({ lostOrders }) => ({
  lostOrders: lostOrders.lostOrders,
  date: lostOrders.date,
  managers: lostOrders.managers,
  loading: lostOrders.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetLostOrders: () => dispatch(getLostOrders()),
  // onAddLostOrder: lostOrder => dispatch(addLostOrder(lostOrder)),
  // onUpdateLostOrder: lostOrder => dispatch(updateLostOrder(lostOrder)),
  // onDeleteLostOrder: lostOrder => dispatch(deleteLostOrder(lostOrder)),
  // onAddBattlefield: (battle) => dispatch(addBattlefield(battle)),
  dispatch,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LostOrdersList))
